import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import USTemplateDefault from 'src/components/template/us'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
import { usPlanData } from 'src/constants/planData/usPlanData'
import { useCountdownTest } from 'src/modules/hooks/useCountdownTest'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { selectAnalyticsReady } from 'src/modules/reducers/analytics'
import { fireUIRenderEvent } from 'src/modules/analytics/v3'

const NFLTemplate = (props) => {
  const teamId = props?.teamId ? String(props.teamId) : null
  const stateForProtobuf = useSelector(selectStateForProtobuf)
  const isAnalyticsReady = useSelector(selectAnalyticsReady)
  const isEventSent = useRef(false)

  const {
    matchCountdownTimer,
    matchTitle,
    pageTitle: countdownPageTitle,
    teamMatches,
  } = useCountdownTest(teamId, null, true)

  let teamTitle = 'Watch football and more'
  let pageTitle = 'Watch football and more'

  if (props.teamShort) {
    teamTitle = `Watch ${props.teamShort} football live`
  }

  if (props.team) {
    pageTitle = `Watch ${props.team} football live`
  }

  // Use countdown page title if available, otherwise fall back to default
  if (countdownPageTitle) {
    pageTitle = countdownPageTitle
  }

  useEffect(() => {
    if (!isEventSent.current && isAnalyticsReady && teamMatches.length) {
      fireUIRenderEvent(
        {
          component: 'countdown_timer_has_game',
        },
        stateForProtobuf
      )
      isEventSent.current = true
    }
  }, [isAnalyticsReady, teamMatches.length])

  return (
    <StyledContainer>
      <USTemplateDefault
        {...props}
        location={props.location}
        lang="en"
        market="us"
        poster={
          props.poster ||
          'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL-PLAYER-STATIC-HORZ-V2.jpg'
        }
        posterMobile={
          props.posterMobile
            ? props.posterMobile
            : props.poster
              ? null
              : 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL-PLAYER-STATIC-VERT-V2.jpg'
        }
        countdownTimer={matchCountdownTimer}
        title={matchTitle || props.title || teamTitle}
        pageTitle={pageTitle}
        subtitle={
          matchTitle ? null : props.subtitle || 'Stream CBS, ESPN, FOX and 200+ live channels'
        }
        networkSet="nfl"
        // teams
        team={props.team}
        // Remove cable references
        removeCable={true}
        matchtickerSportId={sportIds.Football}
        matchtickerLeagueName="NFL"
        matchtickerLeagueId={leagueIds.NFL}
        showRedzone={false}
        sportId={sportIds.Football}
        leagueId={leagueIds.NFL}
        hasPlanCards={false}
        plans={[usPlanData.elite_monthly, usPlanData.pro_monthly]}
        disableAnchor={true}
      />
    </StyledContainer>
  )
}

export default NFLTemplate

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 800px;
  }
`
